export { StickySidebarListCategories as default } from './sticky-sidebar-list-categories';
